/**
 * @auctogon/core/isomorphic/lifecycle — ADR 023 predicate-as-truth phase
 * derivation (BL-639). Client-safe barrel: the pure IsomorphicService
 * predicates + their token/type vocabulary ONLY.
 *
 * The SQL mirror (`auctionPhaseWhere` / `lotPhaseWhere`) is SERVER-ONLY (it
 * imports `@auctogon/db/schema`) and is deliberately NOT re-exported here —
 * import it from the dedicated subpath `@auctogon/core/services/lifecycle/sql`
 * so it never transits the root barrel (sharing.md §3 root-barrel hygiene).
 */
export * from './phase-tokens';
export * from './lifecycle-stamp-columns';
export * from './lot-phase-predicates';
// BL-1421: pure + client-safe. Its SERVER-ONLY SQL mirror (liveSafeLotExistsSql /
// liveSafePhaseAggregatesSql) stays in ./phase-where, reachable only via the
// `@auctogon/core/services/lifecycle/sql` subpath — client-safe-barrel.test.ts
// fails the build if that module becomes reachable from here.
export * from './live-safe';
export * from './lot-openability';
// BUG-1542: the shared close-time adjust baseline — the server's write and the
// modal's preview must resolve it through the same function.
export * from './close-time-adjust';
export * from './can-batch-apply';
export * from './lot-transition-guard';
export * from './auction-refusal-copy';
export * from './landing-target-preconditions';
export * from './lot-transition-catalog';
// BL-1301: the shared "what can I do from here" fold. Pure and structural — it
// imports neither catalog, so it adds nothing to the client bundle's graph.
export * from './transition-options';
export * from './auction-transition-guard';
export * from './auction-transition-catalog';
export * from './lot-field-editability';
export * from './lot-edit-scope';
export * from './auction-field-editability';
export * from './lot-status-ceiling';
// BL-2896: the close's Sold / No Sale / Withdrawn tally, shared with the Auction summary.
export * from './lot-disposition-tally';
export { deriveAuctionPhase } from './derive-auction-phase';
export { deriveLotClosedAt, deriveLotPhase, deriveTerminalDisposition } from './derive-lot-phase';
export {
  deriveAuctionPhaseCoarse,
  type AuctionCoarsePhaseKind,
  type AuctionPhaseCoarseInput,
} from './derive-auction-phase-coarse';
export {
  deriveAuctionPhaseKind,
  isAuctionAwaitingClose,
  isPreOpenAuctionPhase,
  isOpenedAuctionPhase,
  isPublishedScheduleAuctionPhase,
  type AuctionPhaseKindInput,
  type AuctionAwaitingCloseInput,
  type PreOpenAuctionPhaseKind,
  type OpenedAuctionPhaseKind,
  type PublishedScheduleAuctionPhaseKind,
} from './derive-auction-phase-kind';
export * from './customer-field-editability';
// BL-2279 (PRJ-89): the post-close settlement stage, derived from its stamps.
export * from './derive-close-stage';
// BL-2282 (PRJ-89): the house's word for a closed auction and its stages.
export * from './close-stage-label';
